import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { get, uniq } from 'lodash'
import { compose } from 'recompose'

import { ConfigKey, ConfigKeyEmailGroup } from 'containers/forms/configuration'
import { ProfileQuestions } from 'containers/pages'
import { Section, SubTabs, SubTab, Span } from 'components/layout'
import { ConfigurationKeySetModal, ConfigurationEmailSetModal, BulkConfigUpdateModal } from 'components/modals'
import { apiConfiguration, apiCodeLists, apiContacts, apiCommon, apiPersons } from 'helpers/decorators/api'
import { meta, form, permissions as appPermissions } from 'helpers/decorators'
import shouldConfigBeVisible from 'helpers/config-key-visibility'
import { codeListsByIdSelector } from 'redux/selectors/codeLists'
import { CONFIGURATION_KEYS, CONFIGURATION_TYPES } from 'constants/enums'
import ConfigLoader from 'components/loaders/ConfigLoader/ConfigLoader'
import styles from '../../forms/configuration/ConfigKey/config-key.styl'
import { nonSystemlocalesDropdownSelector } from '../../../redux/selectors/locales'
import { bulk as bulkApi } from '../../../redux/modules/api'
import { modal } from '../../../redux/modules/app'
import ConfigurationTTSetModal from '../../../components/modals/configurations/ConfigurationTTSetModal'

const enhance = compose(
  meta({
    title: 'Customizations',
    intlKey: 'pageTitle.customizations',
    dynamicProp: 'organizations.detail.name',
    dynamicPropId: 'organizations.detail.globalId'
  }),
  apiConfiguration({
    allValues: true
  }),
  appPermissions(),
  form({
    form: 'form-change-config-value'
  }),
  apiCodeLists(),
  apiCommon({
      locales: true
    }),
  apiPersons(),
  connect(state => ({
    codeListsById: codeListsByIdSelector(state),
    dropdownLocales: nonSystemlocalesDropdownSelector(state),
    bulkResult: state.api.bulk.bulkChangeResult,
    profileQuestions: state.api.profileQuestions
  }),
      {
        bulkSetResult: bulkApi.setBulkChangeResult,
        modal
      }

      ),
  apiContacts({
      active: true
  })
)

class OrganizationCustomization extends Component {
  static propTypes = {
    configuration: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    isConfigUpdating: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    fetchCodeListById: PropTypes.func.isRequired,
    codeListsById: PropTypes.array,
    change: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    onUpdateConfigKey: PropTypes.func.isRequired,
    onUpdateConfigKeyBulk: PropTypes.func.isRequired,
    onResetConfigKey: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isSameLevel: PropTypes.bool,
    contacts: PropTypes.object.isRequired,
    dropdownLocales: PropTypes.array,
    common: PropTypes.object,
    bulkResult: PropTypes.object,
    bulkSetResult: PropTypes.func,
    profileQuestions: PropTypes.object
  }

  state = {
    config: {},
    emailContentCfg: {},
    emailSubjectCfg: {},
    key: null
  }

  key = uuid.v1()

  handleChangeConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-key-${this.key}`)
      }
    )
  }

  handleChangeTranslationTextConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-tt-key-${this.key}`)
      }
    )
  }

  handleChangeEmail = (emailSubjectCfg, emailContentCfg) => {
    this.setState(
        {
          emailSubjectCfg,
          emailContentCfg,
          key: uuid.v1()
        },
        () => {
          this.props.modal(`modal-configuration-email-key-${this.state.key}`)
        }
    )
  }

  handleShouldBeVisible = (category, activeRole) =>
    category.values.some(config => shouldConfigBeVisible(activeRole, config))

  getConfigKeyForCategory(item, emailSubGroups, activeOrganization, isSameLevel, route, category, editCustomizationEnabled) {

    const isTranslationText = get(item, 'configurationKey.valueType') === CONFIGURATION_TYPES.textTranslated.id

    const isAwardLeaderTraining = CONFIGURATION_KEYS.awardLeaderTrainings.id === get(item, 'configurationKey.keyName.value')

    if (category !== 'EMAIL') {
      return (<ConfigKey
          key={item.id}
          config={item}
          onConfigEdit={(isTranslationText && !isAwardLeaderTraining) ? this.handleChangeTranslationTextConfig : this.handleChangeConfig}
          activeOrganization={activeOrganization}
          standalone={false}
          isSameLevel={isSameLevel}
          editCustomizationEnabled={editCustomizationEnabled}
          options={{
            isIc: get(route, 'isIc'),
            isTypeId: get(route, 'isTypeId')
          }}
      />)
    }
  }

  mapSubGroup = (groups, category) => {
    let mappedSubGroup = {}

    const emailGroup = get(groups, category)

    emailGroup && emailGroup.values.forEach(i => {
          let subGroup = get(i, 'configurationKey.keySubGroup')

          subGroup = subGroup !== null ? subGroup : 'DEF_SUB_GROUP'

          if (mappedSubGroup[subGroup]) {
            mappedSubGroup[subGroup].push(i)
          } else {
            mappedSubGroup[subGroup] = [i]
          }
        }
    )

    return mappedSubGroup
  }

  getEmails = (emailSubGroups, activeOrganization, isSameLevel, route, editCustomizationEnabled) => {
    let result = []

    let id = null

    let emailContentCfg = null

    let emailSubjectCfg = null

    for (const [key, value] of Object.entries(emailSubGroups)) {
      if (key === 'DEF_SUB_GROUP') {
        value.forEach(item => {
          result.push(<ConfigKey
              key={item.id}
              config={item}
              onConfigEdit={this.handleChangeConfig}
              activeOrganization={activeOrganization}
              standalone={false}
              isSameLevel={isSameLevel}
              editCustomizationEnabled={editCustomizationEnabled}
              options={{
                isIc: get(route, 'isIc'),
                isTypeId: get(route, 'isTypeId')
              }}
          />)
        })
      } else {
        value.forEach(item => {
          const categoryType = get(item, 'configurationKey.categoryType.value')

          if(categoryType === 'EMAIL_SUBJECT') {
            emailSubjectCfg = item
          } else {
            id = item.id
            emailContentCfg = item
          }
        })

        result.push(<ConfigKeyEmailGroup
            key={id}
            emailSubjectCfg={emailSubjectCfg}
            emailContentCfg={emailContentCfg}
            onConfigEdit={this.handleChangeEmail}
            activeOrganization={activeOrganization}
            standalone={false}
            isSameLevel={isSameLevel}
            editCustomizationEnabled={editCustomizationEnabled}
            options={{
              isIc: get(route, 'isIc'),
              isTypeId: get(route, 'isTypeId')
            }}
        />)
      }
    }

    return result
  }

  handleBulkConfigUpdateConfirmed = () => {
        this.props.modal(null)
        this.props.onRefreshPage()
    }

  render() {
    const {
      configuration,
      handleSubmit,
      activeOrganization,
      isSameLevel,
      route,
      permissions,
      contacts,
      dropdownLocales,
      common,
      bulkResult,
      profileQuestions
    } = this.props

    const activeUserContact = get(contacts, 'active')

    const editCustomizationEnabled = get(activeUserContact, 'editCustomizationEnabled')

    const values = configuration.allValues.filter(item => {
      return get(item, 'configurationKey.valueType') !== 'CODE_LIST_VALUE'
    })

    let groups = {}

    let groupCategories = []

    for (const item of values) {
      const thisGroupText = get(
        item,
        'configurationKey.keyGroup.translationText'
      )
      const thisGroupValue = get(item, 'configurationKey.keyGroup.value')

      groupCategories = groupCategories.concat(thisGroupValue)

      groups = {
        ...groups,
        [thisGroupValue]: {
          name: thisGroupText,
          groupValue: thisGroupValue,
          values: groups[thisGroupValue]
            ? groups[thisGroupValue].values.concat(item)
            : [].concat(item)
        }
      }
    }

    let emailSubGroups = this.mapSubGroup(groups, 'EMAIL')

    groupCategories = uniq(groupCategories)

    // add profile questions
    groupCategories = groupCategories.concat('PROFILE_QUESTIONS')

    // groupCategories array always contains at least PROFILE_QUESTIONS
    // So, we consider the tabs as loading, if the configuration array contains 1 or less category
    // Or if profileQuestions are loading
    const loading = configuration.allValues.length <= 1 || profileQuestions.loading

    return (
      <div>
      <Section loading={loading} contentLoader={<ConfigLoader />}>
        <SubTabs compact>
          {groupCategories.map((category, i) => {
            if (category === 'PROFILE_QUESTIONS') {
              return (
                <SubTab title="Reg. Questions" intlKey="tabs.registration_questions" key={i}>
                  <ProfileQuestions
                      {...this.props}
                      activeOrganization={activeOrganization}
                      editCustomizationEnabled={editCustomizationEnabled}
                      options={{
                          isIc: get(route, 'isIc'),
                          isTypeId: get(route, 'isTypeId')
                      }}
                  />
                </SubTab>
              )
            }

            if (category === 'EMAIL') {
              return (
                  <SubTab title={groups[category].name} key={i}>
                    {this.getEmails(emailSubGroups, activeOrganization, isSameLevel, route, editCustomizationEnabled)}
                  </SubTab>
              )
            }

            if (
              !this.handleShouldBeVisible(
                groups[category],
                permissions.activeRole
              )
            ) {
              return null
            }

            const getOnlineMasterCardPayment = configuration.allValues.filter(
              item =>
                get(item, 'configurationKey.keyName.value') ===
                String(CONFIGURATION_KEYS.onlineMasterCardPayment.id)
            )[0]

            if (
              groups[category].groupValue === 'MPG_PAYMENT' &&
              !getOnlineMasterCardPayment.booleanValue
            ) {
              return null
            }

            return (
              <SubTab title={groups[category].name} key={i}>
                {category === 'PART_REG_CUS' &&
                <span className={`${styles.blockDescription}`} style={{ marginBottom: 20 }}>
                  <Span intlKey="label.par_reg_cust_note">
                    This tab allows you to customise fields that are displayed at the participant registration and affect the amount of data you are collecting. If you want to hide some fields contact IAF support.
                  </Span>
                </span>}
                {groups[category].values &&
                groups[category].values.map(item => (
                    this.getConfigKeyForCategory(item, emailSubGroups, activeOrganization, isSameLevel, route, category, editCustomizationEnabled)
                ))}
              </SubTab>
            )
          })}

        </SubTabs>
      </Section>
        <ConfigurationKeySetModal
          modalId={`modal-configuration-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
          fetchCodeListById={this.props.fetchCodeListById}
          codeListsById={this.props.codeListsById}
        />

        <ConfigurationTTSetModal
          modalId={`modal-configuration-tt-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
          fetchCodeListById={this.props.fetchCodeListById}
          codeListsById={this.props.codeListsById}
          onUpdateConfigKeyBulk={this.props.onUpdateConfigKeyBulk}
          dropdownLocales={dropdownLocales}
          common={common}
          bulkSetResult={this.props.bulkSetResult}
        />

        <ConfigurationEmailSetModal
            modalId={`modal-configuration-email-key-${this.state.key}`}
            emailSubjectCfg={this.state.emailSubjectCfg}
            emailContentCfg={this.state.emailContentCfg}
            handleSubmit={handleSubmit}
            onUpdateConfigKeyBulk={this.props.onUpdateConfigKeyBulk}
            onResetConfigKey={this.props.onResetConfigKey}
            modal={this.props.modal}
            reset={this.props.reset}
            change={this.props.change}
            initialize={this.props.initialize}
            isConfigUpdating={this.props.isConfigUpdating}
            fetchCodeListById={this.props.fetchCodeListById}
            codeListsById={this.props.codeListsById}
            dropdownLocales={dropdownLocales}
            common={common}
            bulkSetResult={this.props.bulkSetResult}
        />

          <BulkConfigUpdateModal
              modalId="bulk-config-update-modal"
              successfulCount={bulkResult.successfulCount}
              unsuccessfulCount={bulkResult.unsuccessfulCount}
              errorResults={bulkResult.bulkErrorResults}
              onConfirmed={this.handleBulkConfigUpdateConfirmed}
          />


      </div>
    )
  }
}

export default enhance(OrganizationCustomization)
